<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0;">
    <span>角色管理</span>
    <span style="color: #888; font-size: 12px;">角色为固定字典,不可增删,仅可启用/禁用</span>
  </div>
  <div class="page-main_box">
    <el-table
      :data="tableData"
      v-loading="isLoading"
      border
      stripe
      style="width: 100%;">
      <el-table-column prop="roleName" label="角色名称" min-width="150"></el-table-column>
      <el-table-column prop="roleType" label="roleType" min-width="120"></el-table-column>
      <el-table-column label="是否可用" min-width="120">
        <template slot-scope="{ row }">
          <!-- 单向绑定:接口成功后再改状态,失败自动回滚 -->
          <el-switch
            :value="row.available"
            :disabled="row._loading"
            @change="toggleAvailable(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" min-width="180"></el-table-column>
    </el-table>
  </div>
</div>
</template>

<script>
import { roleList, roleUpdateAvailable } from '@/service/apis/bdAdminRole'
import { getRoletype } from '@/utils/getUser'

export default {
  name: 'system-role',
  computed: {
    roleType () {
      return getRoletype()
    }
  },
  data () {
    return {
      tableData: [],
      isLoading: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.isLoading = true
      roleList.call(this).then(res => {
        this.tableData = (res || []).map(r => ({ ...r, _loading: false }))
      }).finally(() => {
        this.isLoading = false
      })
    },
    toggleAvailable (row) {
      const next = !row.available
      this.$set(row, '_loading', true)
      roleUpdateAvailable.call(this, { id: row.id, available: next }).then(() => {
        row.available = next
        this.$message.success(next ? '已启用' : '已禁用')
      }).finally(() => {
        this.$set(row, '_loading', false)
      })
    }
  }
}
</script>
